export function useOpenGoogleCalendar(startDate: Date, title: string) {
  const url = new URL('https://www.google.com/calendar/event');
  const date = new Date(startDate).toISOString().replace(/-|:|\.\d+/g, '');
  url.searchParams.append('action', 'TEMPLATE');
  url.searchParams.append('dates', `${date}/${date}`);
  url.searchParams.append('text', title);

  return () => window.open(url, '_blank');
}
